<template>
  <v-card flat class="dialog-card">
    <v-toolbar flat light color="white">
      <v-toolbar-title>{{ $t('debtDetails') }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon @click="$emit('close')">
        <v-icon>fa-times</v-icon>
      </v-btn>
    </v-toolbar>
    <v-divider></v-divider>
    <v-container fluid>
      <v-row>
        <v-col cols="12">
          <bill-rows :debt="debt"></bill-rows>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
  import BillRows from '../Tabs/BillRows.vue'

  export default {
    props: ['debt'],
    components: {
      'bill-rows': BillRows
    }
  }
</script>

